import "can/map/";
import "can/map/define/";
import Accounts from "src/models/accounts";


const SwitchAccountViewModel = can.Map.extend({
    placeholder: null,
    accounts: [],
    subaccounts: [],
    allAccounts: [],
    flattenedAccounts: [],
    accountName: "",
    selectedAccount: null,
    selectedAccountName: "",
    isUserRoleVTAdmin: false,
    dialog: "",
    define: {
        accountsPromise: {
            get: function() {
                "use strict";
                let params = ( _.filter( Vistracks.myUser.permissions, { name: "PERM_IS_SYS_ADMIN" }).length ) ?
                        { "root-account-id": 0 } :
                        { "root-account-id": Vistracks.myUser.accountId };

                if ( _.filter( Vistracks.myUser.permissions, { name: "PERM_IS_SYS_ADMIN" }).length ) {
                    this.attr( "isUserRoleVTAdmin", true );
                }

                return can.when(
                    Accounts.findChildAccounts( params )
                ).then(
                    responseData => this.attr( "accounts", responseData ),
                    responseError => Vistracks.HelperUtils.jqXHR.errorHandler( responseError )
                );
            }
        }
    },

    hasAccountIn: function( topAccount, filteredAccounts ) {
        "use strict";

        let hasAccount = false,
            self = this;

        if ( topAccount.hasOwnProperty( "subAccounts" ) ) {
            _.forEach( topAccount.subAccounts, sub => {
                if ( hasAccount ) { return false; }
                if ( !_.some( filteredAccounts, ( f ) => f.id == sub.id ) ) {
                    hasAccount = self.hasAccountIn( sub, filteredAccounts );
                } else {
                    hasAccount = true;
                    return false;
                }
            })
        } else {
            hasAccount = _.some( filteredAccounts, ( f ) => f.id == topAccount.id );
        }

        return hasAccount;
    },

    flattenAccounts: function( accounts, arr ) {
        "use strict";
        let self = this;
        arr = arr ? arr : [];

        _.forEach( accounts, ( acc ) => {
            arr.push({ id: acc.id, name: acc.name });
            if ( acc.hasOwnProperty("subAccounts") ) {
                arr = _.merge( arr, self.flattenAccounts( acc.subAccounts, arr ) );
            }
        })

        return _.uniqBy( arr, 'id' );

    },

    searchAccount: function( el ) {
        "use strict";
        let self = this;

        if ( self.attr( "globalTimeout" ) !== null ) {
            clearTimeout( self.attr( "globalTimeout" ) );
        }

        // Should only filter results if number of char is greater than 1 or empty for show all
        if ( $( el ).val().length == 1 ) {
            return false;
        }

        self.attr(
            "globalTimeout",
            setTimeout(function() {
                let allAccounts = self.attr( "allAccounts" ),
                    accountsTree = self.attr( "accounts" ),
                    filteredAccounts = _.filter( allAccounts, function( item ) {
                        return item.lname.indexOf( $( el ).val().toLowerCase() ) > -1;
                    }),
                    accountIds = [];

                if ( self.dialog && self.dialog.indexedButtons && self.dialog.indexedButtons.save ) {
                    if (typeof self.dialog.indexedButtons.save.prop === "function") {
                        self.dialog.indexedButtons.save.prop("disabled", true);
                    }
                }

                let childAccounts = $( "#child-accounts" );
                childAccounts.html( "" );

                var flattenedFilteredAccounts = [];

                if ( $( el ).val() != "" ) {
                    flattenedFilteredAccounts = self.flattenAccounts( filteredAccounts );
                } else {
                    flattenedFilteredAccounts = self.attr( "flattenedAccounts" );
                }

                _.forEach( accountsTree, ( acc ) => {
                    if ( self.hasAccountIn( acc, flattenedFilteredAccounts ) ) {
                        self.getChildren( acc, childAccounts, accountIds, flattenedFilteredAccounts );
                    }
                })

                let groups = childAccounts.find( "[role='group']" ),
                    accounts = childAccounts.find( ".account" );

                _( groups ).forEach( item => {
                    let $el = $( item );
                    if ( $el.children("#sub-accounts").is(":visible") ) {
                        $el.prepend( "<i class='fa fa-minus fa-fw'></i>" );
                    } else {
                        $el.prepend( "<i class='fa fa-plus fa-fw'></i>" );
                    }
                });

            }, 300 )
        );
    },

    getChildren: function( account, el, accountIds, filteredAccounts ) {
        "use strict";

        let self = this,
            groupParent = "<li role='group' group-id='" + account.id + "'></li>",
            groupChild = "<li group-id='" + account.id + "'></li>",
            spanChild = "<span data-id='" + account.id + "' class='account group-label rendered'>" + account.name + "</span>",
            groupChildren = "<ul id='sub-accounts' style='display:none' subs-id='" + account.id + "'></ul>",
            groupChildrenShown = "<ul id='sub-accounts' subs-id='" + account.id + "'></ul>";

        if ( self.hasAccountIn( account, filteredAccounts ) || _.some( filteredAccounts, ( acc ) => acc.id == account.id ) ) {
            if ( account.subAccounts !== undefined ) {

                el.append( groupParent );

                let els = el.find( "[group-id='" + account.id + "']" );
                els.append( spanChild );
                if ( !_.some( filteredAccounts, ( acc ) => acc.id == account.id ) ) {
                    els.append( groupChildrenShown );
                } else{
                    els.append( groupChildren );
                }

                accountIds.push( account.id );

                let elss = els.find( "[subs-id='" + account.id + "']" );
                _( account.subAccounts ).forEach( subAccount => {
                    if ( self.hasAccountIn( subAccount, filteredAccounts ) || _.some( filteredAccounts, ( acc ) => acc.id == subAccount.id ) ) {
                        self.appendChildren( subAccount, elss, accountIds, filteredAccounts );
                    }
                });

            } else {

                el.append( groupChild );

                let els = el.find( "[group-id='" + account.id + "']" );
                els.append( spanChild );
                accountIds.push( account.id );

            }
        }
    },

    appendChildren: function( account, el, accountIds, filteredAccounts ) {
        "use strict";
        let self = this,
            spanChild = "<span data-id='" + account.id + "' class='account group-label'>" + account.name + "</span>";

        if ( account.subAccounts !== undefined ) {
            self.getChildren( account, el, accountIds, filteredAccounts );
        } else {
            el.append( spanChild );
            accountIds.push( account.id );
        }

    },

    selectFirstAccount: function( event ) {
        "use strict";
        event.preventDefault();
        let $elements = $( "li", "#child-accounts" );

        // Iterate through the search results and find the account's name the user typed in
        // then auto click that account name and disable the `Switch` button of the modal
        // and stop the iteration.
        if ( $elements.length > 0 ) {
            $elements.each( ( index, el ) => {
                let $el = $( el ),
                    $span = $el.children( "span" );
                if ( $span.text().toLowerCase() === this.attr( "accountName" ).toLowerCase() ) {
                    if (this.dialog && this.dialog.indexedButtons && this.dialog.indexedButtons.save && typeof this.dialog.indexedButtons.save.prop === "function") {
                        this.dialog.indexedButtons.save.prop( "disabled", false );
                    }
                    $span.trigger( "click" );
                    return false;
                }
            });

            if ( $elements.length === 1 ) {
                if (this.dialog && this.dialog.indexedButtons && this.dialog.indexedButtons.save && typeof this.dialog.indexedButtons.save.prop === "function") {
                    this.dialog.indexedButtons.save.prop( "disabled", false );
                }
                $( $elements[ 0 ] ).children( "span" ).trigger( "click" );
            }
        } else {
            if (this.dialog && this.dialog.indexedButtons && this.dialog.indexedButtons.save && typeof this.dialog.indexedButtons.save.prop === "function") {
                this.dialog.indexedButtons.save.prop( "disabled", true );
            }
        }


        return false;
    },

    renderSubAccounts: function( id, allAccounts ) {

        let account = _.find( allAccounts, ( a ) => a.id == id );

        let self = this,
            groupParent = "<li role='group' group-id='" + id + "'></li>",
            groupChild = "<li group-id='" + id + "'></li>",
            spanChild = "<span data-id='" + id + "' class='account group-label'>" + account.name + "</span>",
            groupChildren = "<ul id='sub-accounts' style='display:none' subs-id='" + account.id + "'></ul>";

        if ( account.hasOwnProperty("subAccounts") ) {
            _.forEach( account.subAccounts, acc => {
                let html = "";
                if ( acc.hasOwnProperty("subAccounts") ) {
                    html += "<li role='group' group-id='" + acc.id + "'>" +
                        "<i class='fa fa-plus fa-fw'></i>" +
                        "<span data-id='" + acc.id + "' class='account group-label'>" + acc.name + "</span>" +
                        "<ul id='sub-accounts' style='display:none' subs-id='" + acc.id + "'></ul>" +
                        "</li>";
                } else {
                    html += "<span data-id='" + acc.id + "' class='account group-label'>" + acc.name + "</span>"
                }

                $("#child-accounts li[group-id=" + id + "] > ul").append(html);
            });
        }

    }
});

export default SwitchAccountViewModel;
